module.exports = __webpack_public_path__ + "img/Lobby_Video.024cf18c.jpg";